import { jsx } from "react/jsx-runtime";
import { useStyle } from "../use-style";
import {
  findBreakpointOverride,
  getBaseBreakpoint,
  getBreakpointMediaQuery,
  mergeOrCoalesceFallbacks
} from "../../../state/modules/breakpoints";
import { ControlValue } from "./control";
import { RenderHook } from "../components";
import { useBreakpoints } from "../hooks/use-breakpoints";
function useStyleControlCssObject(styleControlData, controlDefinition) {
  const breakpoints = useBreakpoints();
  return {
    ...controlDefinition.config.getStyle(
      findBreakpointOverride(
        breakpoints,
        styleControlData,
        getBaseBreakpoint(breakpoints).id,
        mergeOrCoalesceFallbacks
      )?.value
    ),
    ...breakpoints.reduce((styles, breakpoint) => {
      return {
        ...styles,
        [getBreakpointMediaQuery(breakpoint)]: controlDefinition.config.getStyle(
          findBreakpointOverride(
            breakpoints,
            styleControlData,
            breakpoint.id,
            mergeOrCoalesceFallbacks
          )?.value
        )
      };
    }, {})
  };
}
function useFormattedStyleV2(styleControlData, controlDefinition) {
  const styles = useStyleControlCssObject(styleControlData, controlDefinition);
  return useStyle(styles);
}
function StyleV2ControlValue({
  definition,
  data,
  children,
  control
}) {
  return (data ?? []).reduceRight(
    (renderFn, deviceOverrideData) => (responsiveValue) => {
      return /* @__PURE__ */ jsx(
        ControlValue,
        {
          definition: definition.config.type,
          data: deviceOverrideData.value,
          control: control?.control,
          children: (value) => renderFn([{ ...deviceOverrideData, value }, ...responsiveValue])
        }
      );
    },
    (value) => {
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useFormattedStyleV2,
          parameters: [value, definition],
          children: (value2) => children(value2)
        },
        definition.type
      );
    }
  )([]);
}
export {
  StyleV2ControlValue,
  useFormattedStyleV2
};
//# sourceMappingURL=style-v2.js.map